<div class="tw-container tw-mx-auto tw-p-4">
	<div class="tw-mb-6 tw-flex tw-justify-between tw-items-center">
		<h1 class="tw-text-2xl tw-font-bold">Resources</h1>
		<div class="tw-flex tw-space-x-2">
			<div class="tw-relative">
				<select [(ngModel)]="sortOption" (change)="sortFiles()"
						class="tw-appearance-none tw-bg-white tw-border tw-border-gray-300 tw-rounded tw-py-2 tw-px-4 tw-pr-8 tw-shadow-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500">
					<option value="sortPosition">Phases</option>
					<option value="alphabetical">Alphabetical (A-Z)</option>
					<option value="newest">Date (Newest First)</option>
					<option value="oldest">Date (Oldest First)</option>
				</select>
				<div class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-px-2 tw-text-gray-700">
					<svg class="tw-h-4 tw-w-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path>
					</svg>
				</div>
			</div>
			<button class="tw-px-4 tw-py-2 tw-bg-gray-600 tw-text-white tw-rounded hover:tw-bg-gray-700"
					(click)="downloadAllFiles()" [disabled]="loading || files.length === 0">
				Download All
			</button>
		</div>
	</div>

	<!-- Loading state -->
	<div *ngIf="loading" class="tw-flex tw-justify-center tw-items-center tw-py-8">
		<i class="fa fa-spinner fa-spin tw-text-2xl tw-text-gray-500"></i>
	</div>

	<!-- Empty state -->
	<div *ngIf="!loading && files.length === 0" class="tw-bg-gray-50 tw-rounded-lg tw-p-8 tw-text-center tw-my-8">
		<div class="tw-mb-4">
			<i class="fa fa-folder-open-o tw-text-gray-400 tw-text-6xl"></i>
		</div>
		<h3 class="tw-text-xl tw-font-medium tw-mb-2">No Documents Available</h3>
		<p class="tw-text-gray-500">No resource documents have been uploaded yet.</p>
	</div>

	<!-- Files list -->
	<div class="tw-space-y-3" *ngIf="!loading && files.length > 0">
		<div *ngFor="let file of files" class="tw-bg-gray-100 tw-rounded-md tw-p-3 tw-flex tw-justify-between tw-items-center">
			<div class="tw-flex tw-items-center">
				<div class="tw-mr-3">
					<i class="fa tw-text-5xl" [ngClass]="file.originalFilename | fileType"></i>
				</div>
				<span>{{ file.filename }}</span>
			</div>
			<button class="tw-px-4 tw-py-2 tw-bg-gray-600 tw-text-white tw-rounded hover:tw-bg-gray-700"
					(click)="openFile(file)" [disabled]="downloadingFile === file.id">
				<i *ngIf="downloadingFile === file.id" class="fa fa-spinner fa-spin tw-mr-1"></i>
				{{ downloadingFile === file.id ? 'Opening...' : 'Open' }}
			</button>
		</div>
	</div>
</div>